import dayjs from 'dayjs';

export function formatDt(dateStr) {
    return dateStr ? dayjs(dateStr).format('DD.MM, HH:mm') : '—';
}

export const CODE_TYPE_LABEL = { COIN: 'Обычные', LONG: 'Обесценивающиеся', QUESTION: 'С вопросом' };
export const CODE_TYPES = ['COIN', 'LONG', 'QUESTION'];

// ACTIVE обрабатывается отдельно в TaskOperationRow (бейдж «Активно» только для заданий с useTime).
export const TASK_USE_STATUS = {
    NOT_USED: { label: 'Не использовано', tone: 'muted' },
    FINISHED: { label: 'Завершено', tone: 'done' }
};

export const DUEL_STATUS = {
    ASSIGNED: { label: 'Назначена', tone: 'muted' },
    SET_OWNER_WIN: { label: 'Заявлена победа', tone: 'wait' },
    SET_OWNER_LOSE: { label: 'Заявлено поражение', tone: 'wait' },
    CONFIRM_OWNER_WIN: { label: 'Победа подтверждена', tone: 'done' },
    CONFIRM_OWNER_LOSE: { label: 'Поражение подтверждено', tone: 'lose' },
    NOT_CONFIRM: { label: 'Не подтверждено', tone: 'lose' },
    FINISHED: { label: 'Завершена', tone: 'done' }
};

export const CHALLENGE_STATUS = {
    ASSIGNED: { label: 'Назначен', tone: 'muted' },
    PASSED: { label: 'Пройден', tone: 'wait' },
    COMPLETED: { label: 'Выполнен', tone: 'done' }
};

// Список причин будет расширяться бэкендом — немаппированные значения показываем как есть.
export const EXTERNAL_REASON_LABEL = { BET_WIN: 'Выигрыш в Ставках', UNKNOWN: 'Источник не указан' };

export function participantName(p) {
    const full = `${p.surname || ''} ${p.name || ''}`.trim();
    return full || p.username || 'Без имени';
}

// Ссылка QR-кода: база может приходить с хвостовым слэшем (https://…/neighbor/) и без — нормализуем.
export function qrCodeUrl(qrBaseUrl, path, value) {
    return `${(qrBaseUrl || '').replace(/\/+$/, '')}/${path}/${value}`;
}
